<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

	page: {
		title: 'Новый контакт',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader, Multiselect },

	data() {
        return {
			title: 'Новый контакт',
			items: [],
            contact_uuid: '',
            
            phone: '',
            email: '',
            name1: '',
            name2: '',
            name3: '',

            trackBy: 'id',

            initStatus: [],
            status: null,
            status_options: [
                {id: 'active', name: 'Активен'},
                {id: 'wait', name: 'На модерации'},
                {id: 'blocked', name: 'Заблокирован'},
            ],

            category: null,
            initCategory: [],
            category_options: [],

		}
	},

    watch: {
        initStatus: {
            immediate: true,
            handler(values) {
                this.status = this.status_options.filter(x => values.includes(x[this.trackBy]));
                this.status = this.status[0];
            }
        },
        initCategory: {
            immediate: true,
            handler(values) {
                this.category = this.category_options.filter(x => values.includes(x[this.trackBy]));
                this.category = this.category[0];
            }
        }
    },

	computed: {
        contact_item(){
            return this.$store.getters['contacts/GET_CONTACTS_ITEM'];;
        },
        contacts_categories_list_data(){
            return this.$store.getters['contactsCategories/GET_CONTACTS_CATEGORIES_LIST_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            let user = session.user ? session.user : null;
            return user;
        },
	},

	async mounted() {

        this.contact_uuid = this.$route.params.contact_uuid ? this.$route.params.contact_uuid : '';

        await this.$store.dispatch('contactsCategories/FETCH_CONTACTS_CATEGORIES_LIST', {'sortBy': 'id', 'sortDesc': 'DESC'});
        this.category_options = this.contacts_categories_list_data;

        if(this.contact_uuid !== ''){

            this.title = 'Редактирование контакта';
            document.title = appConfig.title + ' - ' + 'Редактирование контакта';

            await this.$store.dispatch('contacts/FETCH_CONTACTS_ITEM', {'uuid' : this.contact_uuid});

            let contact = this.contact_item;

            this.phone = contact.phone ? contact.phone : '';
            this.email = contact.email ? contact.email : '';
            this.name1 = contact.name1 ? contact.name1 : '';
            this.name2 = contact.name2 ? contact.name2 : '';
            this.name3 = contact.name3 ? contact.name3 : '';

            this.category = contact.category_id ? contact.category_id : null;
            if (this.category !== null) {
                this.initCategory = [this.category];
            }

            this.status = contact.status ? contact.status : '';
            this.initStatus = [this.status];

        } else {
            this.show_create_account = true;
        }
	},

	methods: {

        async saveForm(){

            let data_send = {};
            let result = '';

            data_send = {
                'uuid'   : this.contact_uuid,
                'email'  : this.email,
                'phone'  : this.phone,
                'name1'  : this.name1,
                'name2'  : this.name2,
                'name3'  : this.name3,
                'status' : this.status && this.status.id ? this.status.id : null,
                'category_id' : this.category && this.category.id ? this.category.id : null,
            };

            if(this.contact_uuid === ''){
                result = await this.$store.dispatch('contacts/FETCH_CONTACTS_CREATE', data_send);
            } else {
                result = await this.$store.dispatch('contacts/FETCH_CONTACTS_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Contacts'});
            }
        }
	}
}

</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveForm"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                            <div class="row">
                                <div class="col">

                                    <b-form-group
                                        label="Фамилия"
                                        label-for="name3"
                                    >
                                        <b-form-input
                                            id="name3"
                                            v-model="name3"
                                            placeholder="Укажите Фамилию"
                                        ></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        label="Имя"
                                        label-for="name1"
                                    >
                                        <b-form-input
                                            id="name1"
                                            v-model="name1"
                                            placeholder="Укажите Имя"
                                        ></b-form-input>
                                    </b-form-group>
                                    <b-form-group
                                        label="Отчество"
                                        label-for="name2"
                                    >
                                        <b-form-input
                                            id="name2"
                                            v-model="name2"
                                            placeholder="Укажите Отчество"
                                        ></b-form-input>
                                    </b-form-group>

                                    <br><br>

                                    <b-form-group
                                        label="Номер телефона"
                                        label-for="phone"
                                    >
                                        <b-form-input
                                            id="phone"
                                            v-model="phone"
                                            placeholder="Номер телефона пользователя"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="E-mail адрес"
                                        label-for="email"
                                    >
                                        <b-form-input
                                            id="email"
                                            v-model="email"
                                            placeholder="E-mail адрес, если есть"
                                        ></b-form-input>
                                    </b-form-group>

                                    <br><br>

                                    <b-form-group
                                        label="Группа"
                                        label-for="category"
                                    >
                                        <multiselect
                                            id="category"
                                            v-model="category"
                                            :options="category_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                            :track-by="trackBy"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        label="Статус"
                                        label-for="status"
                                    >
                                        <multiselect
                                            id="status"
                                            :track-by="trackBy"
                                            v-model="status"
                                            :options="status_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>
                                </div>
                            </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
	</Layout>
</template>
